import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, Message, MessageService } from 'primeng/api';
import { Observable, Subscription, catchError, tap } from 'rxjs';

import { AcaoConcurso } from '@app/core/models/acao-concurso';
import { AcoesPossiveis } from '@app/core/models/perfil-profissiografico/acoes-possiveis';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule } from '@angular/common';
import { ConcursoApiService } from '@app/tabelasAdministrativas/services/concurso-api.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { MessageFeedbackComponent } from '../message-feedback/message-feedback.component';
import { MessagesModule } from 'primeng/messages';
import { PerfisEnum } from '@app/core/enums/perfis.enum';
import { Router } from '@angular/router';
import { SharedModule } from '../shared.module';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToastModule } from 'primeng/toast';
import { UiService } from '@app/core/services/ui.service';
import { UsuarioService } from '@sigepe/sigepe-template';
import moment from 'moment';

@Component({
	standalone: true,
	selector: 'sgp-botao-acao-concurso',
	templateUrl: './botao-acao-concurso.component.html',
	providers: [ConfirmationService],
	imports: [
		CommonModule,
		CalendarModule,
		SplitButtonModule,
		DialogModule,
		ConfirmDialogModule,
		ButtonModule,
		MenuModule,
		ToastModule,
		SharedModule,
		FormsModule,
		MessagesModule
	]
})
export class BotaoAcaoConcursoComponent implements OnInit, OnDestroy {
	@Input() messageService!: MessageService;
	@Input() listaAcoes!: AcoesPossiveis[];
	@Input() idConcurso?: number;
	@Input() exibicao: 'tabela' | 'detalhamento' = 'tabela';
	@Output() acaoRealizada = new EventEmitter<void>();
	@ViewChild('btnAcao') btnAcao!: ElementRef;
	
	loading = false;
	submetido = false;
	acoesPossiveis: MenuItem[] = [];
	desabilitar = false;

	
	subscriptions: Subscription[] = [];
	mensagemFeedback: Message[] = [];
	visible = true;
	finalizado = false;

	constructor(
		private concursoApi: ConcursoApiService,
		private tabelaService: ConcursoApiService,
		private router: Router,
		private ui: UiService,
		private confirmationService: ConfirmationService,
		private usuarioService: UsuarioService
	) {}

	ngOnInit(): void {
		this.montarMenu();
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

	montarMenu() {
		//console.log(this.listaAcoes);
		if (this.listaAcoes.length === 0) {
			this.desabilitar = true;
			return;
		}

		for (const acao of this.listaAcoes) {
			const a = new AcaoConcurso();
			a.id = this.idConcurso;
			a.codigo_acao = acao.id!;
			this.acoesPossiveis.push({
				label: acao.nomeAcao,
				command: () => {
					this.executarAcao(this.idConcurso!, a);
				}
			});
		}
		if (this.acoesPossiveis.length === 0) {
			this.desabilitar = true;
		}
	}

	private executarAcao(id: number, acao: AcaoConcurso) {
		this.messageService.clear();
		this.confirmationService.confirm({
			message: 'Esta ação não poderá ser desfeita.',
			header: 'Confirma execução da ação?',
			accept: async () => {
				this.subscriptions.push(
					this.tabelaService.executarAcao(id, acao).subscribe(
						(res: any) => {
							this.rerenderizar();
							this.messageService.add(this.ui.criarMensagem('success', '', res.message));
						},
						err => {
							this.messageService.add(this.ui.criarMensagem('error', '', err.error.message));
						}
					)
				);
			}
		});
	}

	
	private rerenderizar() {
		new Observable<void>(subscriber => {
			setTimeout(() => {
				this.acaoRealizada.emit();
				subscriber.next();
			}, 100);
		}).subscribe();
	}
	
}
